import styled from 'styled-components';
import { BasketSummaryDetailsStyled } from '../../BasketSummaryDetailsStyled';
import { rem } from 'polished';

export const BasketSummaryDetailsOV = styled(BasketSummaryDetailsStyled)`
    background: ${({ theme }) => theme.colors.grey6};

    .title {
        font-size: ${rem(16)};
        background: ${({ theme }) => theme.colors.grey6};

        .label {
            svg {
                g {
                    path {
                        fill: ${({ theme }) => theme.colors.black2} !important;
                    }
                }
            }
        }
    }
    
    .priceSection {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
    }   
    
    .storePrice,
    .totalPrice {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
    }
    
    .totalPrice {
        &_cashPrice, &_monthlyPrice {
            font-size: ${rem(20)};
            font-family: ${({ theme }) => theme.fonts.fontBase};
        }
        
        &_monthlyPrice {
            .prefix,
            .suffix {
                font-family: ${({ theme }) => theme.fonts.fontSecondary};
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            }
        }
    }

    .storePrice,
    .totalPrice,
    .promoCodeResult,
    .dealerDiscountResult,
    .priceSection,
    .ecoBonusWrapper_description {
        border-color: ${({ theme }) => theme.colors.grey3};
    }

    .promoCodeSection {
        .promoCode {
            background: ${({ theme }) => theme.colors.white};
        }
        
        &.isOpen {
            background: ${({ theme }) => theme.colors.white};
            margin: ${rem(10)} 0;
            padding: ${rem(10)};
        }
        
        &_title {
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
            color: ${({ theme }) => theme.colors.grey27};
            margin-bottom: ${rem(5)};
            
            svg {
                path {
                    stroke: unset;
                    stroke-width: 1;
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
            
            &.isHide {
                span {
                    text-decoration: underline;
                    padding-left: ${rem(5)};
                }
            }
        }
        
        .promoCode {
            .promoCodeWrapper {
                padding-top: ${rem(5)};
            }
            
            .promoCodeInfo {
                font-family: ${({ theme }) => theme.fonts.fontSecondary};
                color: ${({ theme }) => theme.colors.grey27};
            }
            
            &__button {
                border-width: ${rem(2)};
                border-color: ${({ theme }) => theme.colors.primary};
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};

                &:hover:enabled {
                    background: ${({ theme }) => theme.colors.white};
                    color: ${({ theme }) => theme.colors.black};
                    border-color: ${({ theme }) => theme.colors.black};
                }
                
                &:disabled {
                    border-color: ${({ theme }) => theme.colors.grey11};
                    color: ${({ theme }) => theme.colors.grey11};
                }
            }
            
            .promoCode__input_label_success {
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }
    }
`;
